// extracted by mini-css-extract-plugin
export default {"main":"VideoPlayer_main__0sJXm","header":"VideoPlayer_header__XhKLJ","return":"VideoPlayer_return__dGZlz"};